import React, { useContext, useEffect } from "react"
import useWindowDimensions from "@hooks/useWindowDimensions";
import { useBlogConfiguration } from ".."
import { FILTER_OPTIONS } from "../../constants"
import { StyledBlogFilterOption } from "../../styled"
import { BlackAndWhiteLayoutContext } from "../../../Common/Layout/Black-White/Context"

  const useFilterOptions = () => {
  const { articleCategories, closeMobileFilters } = useContext(BlackAndWhiteLayoutContext)
  const { isDesktop } = useWindowDimensions();
  const { selectedFilterOption, setSelectedFilterOption } = useBlogConfiguration()

  const handleUserChoice = (filterOption) => {
    if(!!selectedFilterOption.length && filterOption === selectedFilterOption) {
      setSelectedFilterOption("")
    } else {
      setSelectedFilterOption(filterOption)
    }
  }

  useEffect(() => {
    isDesktop && closeMobileFilters();
  }, [isDesktop])

  const filterOptions = articleCategories?.map(({ node: { name } }) => (
    <StyledBlogFilterOption
      key={name}
      isActive={name === selectedFilterOption}
      onClick={() => handleUserChoice(name)}
    >
      {name}
    </StyledBlogFilterOption>
  ))

  return {
    filterOptions,
    closeMobileFilters
  }
}

export default useFilterOptions
